import { useState, type ReactElement } from "react";

import { AppShell } from "../components/AppShell";
import { Tabs, type TabDef } from "../components/Tabs";
import { OverviewTab } from "../components/collab/OverviewTab";
import { ParticipantsTab } from "../components/collab/ParticipantsTab";
import { CollabAccountTab } from "../components/collab/CollabAccountTab";

const TABS: TabDef[] = [
  { id: "overview", label: "Overview", icon: "fas fa-chart-simple" },
  { id: "participants", label: "Participants", icon: "fas fa-users" },
  { id: "account", label: "Account", icon: "fas fa-user" },
];

// The collaborator portal: a study-operations console, deliberately NOT the
// participant dashboard — Overview (stats + CSV export + instructions + the
// consent participants sign), Participants, and a minimal email+password
// Account. No trends, no photo viewing/export, no API keys; exports are CSV.
// Batch upload was removed 2026-08-12 (regulatory) — admin console only.
export function Collab(): ReactElement {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <AppShell brand="FaceAge Collaborator">
      <Tabs tabs={TABS} active={activeTab} onSelect={setActiveTab} label="Collaborator sections" />
      {activeTab === "overview" ? <OverviewTab /> : null}
      {activeTab === "participants" ? <ParticipantsTab /> : null}
      {activeTab === "account" ? <CollabAccountTab /> : null}
    </AppShell>
  );
}
